import { orderBy, uniqBy } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { CardTable } from 'components/datatable/NewTable'
import Checkbox from '../../../components/forms/Checkbox'
import { getHardPiezoDataTypes } from '../../../utils/PiezometryUtils'
import { canShowStationTypeData, getSettingJson } from '../../../utils/SettingUtils'
import { execByType } from '../../../utils/StationUtils'
import SieauParameterDto from '../../dto/SieauParameterDto'
import { darkBlue } from 'utils/constants/ColorTheme'
import { nbPerPageLabel30 } from 'referencial/constants/ReferencialConstants'


const ShowAssociatedDataRuleTable = ({
    fromStationType,
    toStationType,
    currentSettings,
    onChangeRules = () => {},
    readMode,
}) => {
    const {
        piezoDataTypes,
        hydroDataTypes,
        pluvioDataTypes,
    } = useSelector(store => ({
        piezoDataTypes: store.StationReducer.piezoDataTypes,
        hydroDataTypes: store.StationReducer.hydroDataTypes,
        pluvioDataTypes: store.StationReducer.pluvioDataTypes,
    }), shallowEqual)

    const getDataTypes = () => execByType(toStationType, {
        quality: () => [],
        piezometry: () => uniqBy(orderBy([...getHardPiezoDataTypes(), ...piezoDataTypes ], 'id'), 'id'),
        hydrometry: () => orderBy([...hydroDataTypes ], 'id'),
        pluviometry: () => orderBy(pluvioDataTypes, 'id'),
    })

    const getTitle = () => execByType(toStationType, {
        quality: () => i18n.quality,
        piezometry: () => i18n.piezometry,
        hydrometry: () => i18n.hydrometry,
        pluviometry: () => i18n.pluviometry,
    })

    const changeRules = (id, newValue) => {
        const rules = getSettingJson(currentSettings, 'showDataTypesRules') || {}
        const from = rules[fromStationType] || {}
        const to = from[toStationType] || {}

        const newData = { ...to, [id]: newValue }
        const dtKeys = Object.keys(newData).filter(k => k !== 'all')

        const newTo = (() => {
            if (id === 'all' && newValue) {
                return { all: true }
            } else if (dtKeys.length && dtKeys.length === getDataTypes().length && dtKeys.every(k => newData[k] === false)) {
                return { all: false }
            }
            return newData
        })()

        const newFrom = { ...from, [toStationType]: newTo }
        const newRules = { ...rules, [fromStationType]: newFrom }

        onChangeRules(JSON.stringify(newRules))
    }

    const rules = getSettingJson(currentSettings, 'showDataTypesRules') || {}
    const showAll = canShowStationTypeData(fromStationType, toStationType, 'all', rules)
    const data = !showAll ? [] : getDataTypes().map(t => {
        const checked = canShowStationTypeData(fromStationType, toStationType, t.id, rules)
        return {
            show: {
                value: <Checkbox
                    checked={canShowStationTypeData(fromStationType, toStationType, t.id, rules)}
                    onChange={ v => changeRules(t.id, v) }
                    disabled={readMode}
                />,
                sortValue: checked,
            },
            name: t.name || t.label,
            id: t.id,
        }
    })

    return (
        <CardTable
            headers={['show', 'id', 'name']}
            rows={data}
            title={`${i18n.showAdditionalData} : ${getTitle()}`}
            actions={[{
                icon: showAll ? 'check_box' : 'check_box_outline_blank',
                onClick: () => readMode ? null : changeRules('all', !showAll),
                color: 'white',
            }]}
            rowsPerPageOptions={nbPerPageLabel30}
            color={darkBlue}
        />
    )
}

ShowAssociatedDataRuleTable.propTypes = {
    currentSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    fromStationType: PropTypes.string,
    toStationType: PropTypes.string,
    onChangeRules: PropTypes.func,
    readMode: PropTypes.bool,
}

export default ShowAssociatedDataRuleTable